import cn from 'classnames';

import { PAGE_SIZE } from '@/constants/specials/specials.constants';

import styles from './search-results.module.scss';

export function CarTilePlaceholder() {
  return (
    <div className={cn(styles.carTileTextColor, styles.carTile)}>
      <div className={styles.resultsItem}>
        <div className={styles.placeholder}>
          <div className={styles.placeholderImage}></div>
        </div>
      </div>
    </div>
  );
}

export default function SearchResultsPlaceholder() {
  return (
    <>
      {new Array(PAGE_SIZE).fill(null).map((_val, index) => (
        <CarTilePlaceholder key={index.toString()} />
      ))}
    </>
  );
}
